import classNames from 'classnames';
import { IconCheck, IconX } from 'featherico';
import * as React from 'react';
import ReactToggle from 'react-toggle';
import styles from './style.m.less';

interface Props {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: React.ReactNode;
    subLabel?: React.ReactNode;
    id?: string;
}

export default function Toggle({
    checked,
    onChange,
    disabled = false,
    label = undefined,
    subLabel = undefined,
    id,
}: Props) {
    return (
        <React.Fragment>
            <label className={styles.label}>
                <ReactToggle
                    className={styles.reactToggle}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    icons={{
                        checked: <IconCheck className={styles.toggleIcon} />,
                        unchecked: <IconX className={styles.toggleIcon} />,
                    }}
                    id={id}
                />

                {label && (
                    <div className={classNames(styles.labelText, { [styles.labelTextDisabled]: disabled })}>
                        {label}
                    </div>
                )}
            </label>
            {subLabel && <div className={styles.subLabel}>{subLabel}</div>}
        </React.Fragment>
    );
}
